import React from 'react';
import { ClockIcon } from 'lucide-react';
import { useCountdown } from '../hooks/useCountdown';
type CountdownProps = {
  caption?: string;
  dark?: boolean;
};
export function Countdown({
  caption = 'Limited-time special access',
  dark = false
}: CountdownProps) {
  const {
    hours,
    minutes,
    seconds
  } = useCountdown();
  const units = [{
    value: hours,
    label: 'Hours'
  }, {
    value: minutes,
    label: 'Min'
  }, {
    value: seconds,
    label: 'Sec'
  }];
  return <div className="mt-6 text-center" role="timer" aria-live="off" data-id="element-58" data-mp="3h0z615qhlx1t">
      <p className={`flex items-center justify-center gap-2 text-sm font-bold uppercase tracking-wide ${dark ? 'text-gold' : 'text-plum'}`} data-id="element-59" data-mp="3h2a9f4g0t2se">
        <ClockIcon className="h-4 w-4" aria-hidden="true" data-id="element-60" data-mp="372jdcybtafq7" />
        The special offer ends in:
      </p>
      <div className="mt-3 flex items-start justify-center gap-2" data-id="element-61" data-mp="10clc4kxpq8az">
        {units.map((u, i) => <React.Fragment key={u.label} data-id="element-62" data-mp="15by75syqmlon" data-mpi={i}>
            <div className="flex flex-col items-center" data-id="element-63" data-mp="15awj8nwmi4pi">
              <span className="flex h-16 w-16 items-center justify-center rounded-xl bg-plum-dark font-serif text-3xl font-bold tabular-nums text-white shadow-md sm:h-20 sm:w-20 sm:text-4xl" data-id="element-64" data-mp="y0n1tq0onbb3">
                {u.value}
              </span>
              <span className={`mt-1.5 text-[11px] font-semibold uppercase tracking-wider ${dark ? 'text-lavender-deep' : 'text-muted'}`} data-id="element-65" data-mp="17qgekuck9wgx">{u.label}</span>
            </div>
            {i < units.length - 1 && <span className={`pt-4 font-serif text-3xl font-bold ${dark ? 'text-white' : 'text-plum-dark'}`} data-id="element-66" data-mp="f33typpynyq9">:</span>}
          </React.Fragment>)}
      </div>
      <p className={`mt-3 text-sm ${dark ? 'text-lavender-deep' : 'text-muted'}`} data-id="element-67" data-mp="o3ievnz0jbt8">{caption}</p>
    </div>;
}